import React, {Component} from 'react'
import { Waypoint } from 'react-waypoint'

import Player from '../Player/Player'
import Expander from '../Expander/Expander'
import Lock from '../Lock/Lock'

import './styles.scss'

class ChapterFour extends Component {
    constructor(props) {
        super(props);
        this.state = { width: 0, height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
        
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
        
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    render () {
        return (
            <>
                <Waypoint horizontal onEnter={()=>{this.props.chapterTransition("four")}}> 
                    <div className="chapter chapter-four chapter-4" style={{height: this.state.height + "px" }}>
                        <div className="scroll-container bg-back">
                            <div  className="scroll scroll-one"></div>
                        </div>
                        <div className="scroll-container bg-front">
                            <div  className="scroll"></div>
                        </div>
                        <div className="scroll-container man">
                            <div  className="scroll"></div>
                        </div>
                        <div className="scroll-container bear">
                            <div  className="scroll"></div>
                        </div>
                        <div className="scroll-container car">
                            <div  className="scroll"></div>
                        </div>
                        <div className="scroll-container ant">
                            <div  className="scroll"></div>
                        </div>
                        <div className="scroll-container ant-move">
                            <div  className="scroll"></div>
                        </div>
                        <div className="scroll-container one">
                            <div className="white-content scroll">
                                <p><b>Klarer du å gjette hvem som er blant de aller sterkeste i skogen?</b> Det kan hende svaret overrasker deg, fordi det verken er bjørnen, elgen eller bodybuilderen, når han eller hun går tur i skogen. En av de sterkeste i den norske skogen er mauren!</p>
                            </div>
                            <Player file="4_1" />
                        </div>
                        <div className="scroll-container two">
                            <div className="white-content scroll">
                                <p>Mauren er et godt eksempel på at du ikke skal dømme noen etter hvordan de ser ut. Selv om mauren kan virke spinkel, med sine tynne og lange bein, kan den bære 50 ganger sin egen vekt. Hadde du vært like sterk som en maur, kunne du løftet en Tesla over hodet!</p>
                            </div>
                            <Player file="4_2" />
                        </div>
                        <div className="scroll-container three">
                            <div className="white-content scroll">
                                <h2>Selv om mauren er råsterk, er den likevel sårbar.</h2>
                                <p>Bjørnen spiser masse maur, og det er lett for mennesker å ødelegge for den, hvis vi for eksempel tråkker i en maurtue. Det du egentlig tråkker på da er hundretusenvis av arbeidsmaur, mange hundre dronninger, og et samfunn de kan ha brukt over 100 år på å bygge. Best å la være!</p>
                            </div>
                            <Player file="4_3" />
                        </div>
                        <div className="scroll-container four">
                            <div className="white-content scroll">
                                <p>Det finnes så mange maur i verden at hvis vi kunne veid alle sammen, ville de veid mer enn alle menneskene i verden. <b>Wow!</b> Én ting det ikke finnes like mye av er blåveis. For at det skal bli flere blåveiser slipper den frø. Men hvis disse frøene plantes for tett inntil hverandre, kommer frøene til å få hard konkurranse om plass, lys, næring og vann. Derfor har blåveisen inngått et samarbeid med mauren!</p>
                            </div>
                            <Player file="4_4" />
                        </div>
                        <div className="scroll-container five">
                            <div className="white-content scroll">
                                <p>Når det oljete laget er spist opp, er ikke frøet like interessant for mauren lenger. Derfor lar den det ligge, ofte et stykke unna der mauren først fant frøet.</p>
                            </div>
                            <Player file="4_5" />
                        </div>
                        <div className="thank-you">Takk for at du skyller, bretter og stapper skolemelka for mauren!</div>
                        <Expander
                            class="expander-one"
                            content="For å tiltrekke seg den ivrige mauren lager blåveisen et frø med et oljeaktig belegg på. Det har mauren veldig lyst på, det er kanskje like fristende som taco. "
                            chapter='4'
                        ></Expander>
                        <Lock 
                            progress="five"
                            handleModal={this.props.handleModal}
                            >
                        </Lock>
                    </div>
                </Waypoint>
            </>
        )
    }
}
export default ChapterFour